module.exports = __webpack_public_path__ + "HKGrotesk-Bold.55a337a6ba3d12a9ec8f.woff2";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/fonts/HKGrotesk-Bold.woff2
// module id = ../../../../../src/assets/fonts/HKGrotesk-Bold.woff2
// module chunks = styles